/**
    商品列表
**/
<template>
  <div class="rightaside_content ">
        <div class="wholeInfoBox">
          <div>
            <el-image v-if="bigImgSize==0?true:false" class="bigImgSizeCss" :src="item.commodity.photos" @click="$router.push(`/goodsdetail?id=${item.commodity.id}`)">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <el-image v-if="bigImgSize==1?true:false" :src="item.commodity.photos" @click="$router.push(`/goodsdetail?id=${item.commodity.id}`)">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="attentiontOpreate">
              <el-button v-if="item.commodity.isCollect==0?true:false" @click="addCollectionHandle(item.commodity.id)" type="warning" icon="el-icon-star-off"  circle ></el-button>
              <el-button v-if="item.commodity.isCollect==1?true:false" @click="removeCollectionHandle(item.commodity.id)" type="warning" class="star_on" icon="el-icon-star-on"  circle ></el-button>
              <el-button
                v-if='isOpenCart?true:false'
                @click="openGoodsInfo(item.commodity.id)"
                type="warning"
                icon="el-icon-search"
                circle
              ></el-button>
              <el-button v-if="isOpenCart?true:false" @click="removeFooter(item.id)" type="warning" icon="el-icon-close"  circle ></el-button>
            </div>
            <div class="addCartOpreate" v-if='isAddCart?true:false'>
              <span v-if="item.commodity.realprice!=-1&&item.commodity.type!=2" @click="addCart(item.commodity.id,item.commodity.name,item.commodity.specificationlist,item.commodity.status,item.commodity.approvalStatus)"
                ><i class="el-icon-shopping-cart-2"></i>加入购物车</span>
            </div>
            <div class="goodsText">
              <router-link :to="`/goodsdetail?id=${item.commodity.id}`"
                ><p class="OneLineDisplay">{{ item.commodity.name }}</p></router-link
              >
               <p  class="OneLineDisplay" style="color: #ff6700; margin: 3px 0">
                <!-- {{ item.price || 0 }} 元 -->
                 {{ item.commodity.realprice!=-1?`${item.commodity.realprice}元`:'面议'}} 
              </p>
              <!-- <p  v-if='isOpenCart?true:false' class="OneLineDisplay" style="color: #ff6700; margin: 3px 0">
                {{ item.realprice || 0 }} 元
              </p> -->
              <!-- <p v-if='isAddCart?true:false' class="OneLineDisplay">{{ item.evaluator }} 人评价</p> -->
            </div>
          </div>
        </div>        

    <!-- 打开商品详情信息 开始 -->
    <el-dialog
      class="addCartInfoBox"
      :visible.sync="openGoodsVisible"
      center
      :before-close="beforeClose"
      width="1150px"
    >
      <el-row style="margin-bottom: 20px" v-loading="loading">
        <el-col :span="8">
          <div class="fl">
            <div class="fl second-img" id="secondimg">
              <div id="smallBox" style="width:100%;height:100%">
                    <el-image
                    style="width:100%;height:100%"
                      id="smallBox_img"
                      :src="`${bigphotos}`"
                      alt="picture"
                    ></el-image>
              </div>
            </div>
            <div class="smallnav">
              <ul class="smnav" id="smnav">
                <li  @click="selectedImg(item,index)" v-for="(item,index) in moreImgArr" :key="item" :class="isSelectedImg==index?'active':''">
                  <el-image :src="`${item}`" alt=""></el-image>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="fr second-detail">
            <span class="dettitle virtualType" v-if="info.type==2">虚拟商品</span>
            <p class="dettitle">{{ info.name }}</p>
            <!-- <p class="detprice"> ¥149 &nbsp;<i>¥179</i></p> -->
            <div class="introduce">
              <div class="ks clearfix">
                <div class="kuanshi fl">商城价 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  <!-- <span class="dettitle">¥{{(info.price!=null && info.price!="")?info.price: info.marketprice}} </span>  -->
                  <span class="dettitle">¥{{ info.realprice!=-1?info.realprice:'面议' }} </span>
                  降价通知
                </div>
              </div>
              <div class="ks clearfix" v-if="info.realprice!=-1">
                <div class="kuanshi fl">市场指导价 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  <span
                    >¥{{info.marketprice}}</span>
                </div>
              </div>
              <!-- 地址后期开放 -->
              <!-- <div class="ks clearfix">
                <div class="kuanshi fl">配送 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  <el-cascader
                    v-model="cascaderAreaValue"
                    ref="cascaderAddr"
                    class="cascaderArea"
                    placeholder="发货地址"
                    :props="{ checkStrictly: true }"
                    :options="getprovince"
                    @change="areaHandleChange"
                  >
                  </el-cascader>
                  至
                  <el-cascader
                    v-model="shippingAreaValue"
                    ref="cascaderAddr"
                    class="cascaderArea"
                    placeholder="收货地址"
                    :props="{ checkStrictly: true }"
                    :options="getprovince"
                    @change="areaHandleChange"
                  >
                  </el-cascader>
                  <div style="margin: 10px 0px 20px 0"> [快递：¥{{info.postage || 0.0}}]  有货,下单后立即发送  </div>
                </div>
              </div> -->
              <!-- <div class="ks clearfix">
                <div class="kuanshi fl">服务 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  由 <a href=""> 本网站 </a> 发货并提供售后服务 [ 快递：¥{{
                    info.postage || 0.0
                  }}
                  ]
                </div>
              </div> -->
              <!-- <div class="ks clearfix">
                <div class="kuanshi fl">红包 :</div>
                <div class="kuanshi-two fl kuanshi-two1">可用0个</div>
              </div> -->
              <!-- <div class="ks clearfix">
                <div class="kuanshi fl">规格 :</div>
                <div class="kuanshi-two fl kuanshi-two2">
                  <el-radio-group v-model="goodsSize" size="medium">
                    <el-radio
                      border
                      :label="item.bXySid"
                      @change="getgoodsSize(item.realprice, item.bXySid)"
                      v-for="(item, index) in info.specificationlist"
                      :key="index"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </div>
                <span class="select_c" id="select_c"
                  ><i></i>&nbsp;请输入选择材质</span
                >
              </div> -->
              <div class=" ks clearfix" v-for="(item1,index) in attributelist" :key="index">
                <goodsSizeItem :attributelist="item1" :goodsIdArr='goodsIdArr' :getgoodsSize='getgoodsSize'></goodsSizeItem>
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">数量 :</div>
                <div class="number fl">
                  <el-input-number
                    v-model="info.number"
                    @change="handleChange"
                    :min="1"
                    :max="10"
                    label="描述文字"
                  ></el-input-number>
                </div>
              </div>

              <div class="buygoods" v-if="info.realprice!=-1">
                <a
                  href="javascript:;"
                  class="rightnow2 fl"
                  id="rightnow2"
                  @click="orderNow(info.status,info.approvalStatus)"
                  >立即购买</a
                >
                <a
                  href="javascript:;"
                  style="color: white"
                  class="addcar2 fl"
                  id="addcar2"
                  v-if="info.type!=2"
                  @click="onAddCar(info.id,info.number,info.bXySid,info.status,info.approvalStatus)"
                >
                  <i class="addshopcar"></i>加入购物车</a
                >
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 打开商品详情信息 结束 -->

    <!-- 加入购物车弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="addDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">已成功加入购物车！</div>
        <!-- <div>{{ addGoodsName }}</div> -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">继续购物</el-button>
          <el-button type="primary" @click="$router.push('/shoppingcart')"
            >去购物车结算</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
    <!-- 加入购物车结束 -->
  </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
import goodsSizeItem from '@/components/goodsSize' // 商品规格
import { shoppingCartlist,commoditylist,getAttributelist,getSpecificationDetail, addShoppingCart, area_list,addCollection,removeCollection,removefoot } from "@/api/xunyou";
export default {
  data() {
    return {
       userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
       loading:false,
      successInfo: true,
      addDialogVisible: false,
      openGoodsVisible: false,
      goodsList: [],
      info: {},
      goodsSize: "",
      attributelist:[],
      specificationlist:[],
      goodsIdArr:[], // 选中的属性对象数组
      idArr:[], // 选中的属性id集合
      selectAttrId:'',
      num1: 1, //商品数量
      // getprovince: [], // 地址联动
      cascaderAreaValue: [], // 发货地址
      shippingAreaValue: [], // 收货地址
      moreImgArr:[],
      bigphotos:'',
      isSelectedImg:'',  
      selected:false,
      selectedImgUrl:'', // 选择的图片路径
      goodsId:'', // 点击的商品id
    };
  },
   props: ['item','isAddCart','isOpenCart','getcollectionList','bigImgSize'],
  // 注册组件
  components: {goodsSizeItem},
  computed:{
    ...mapState(['getprovince'])
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    // this.getprovinceList();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    removeFooter(id){
      console.log(id);
      removefoot({
        uid:this.userInfo.userId,
        ids:id
      }).then(res=>{
        if(res.code==0){
          this.$message.success('操作成功')
          setTimeout(() => {
            this.$router.go(0)
          }, 500);
        }
      })
    },
    //   选择的图片
    selectedImg(url,index){
        this.selected = true;
        this.isSelectedImg = index;
        this.selectedImgUrl = url
        this.bigphotos = url
    },
      // 添加收藏
    addCollectionHandle(id) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      // this.loading = true;
      const req ={
        type:1, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 商品id
      }
      addCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.item.isCollect = 0
            this.getcollectionList()
          }
        })
        .catch((err) => {
          this.$message.error("收藏失败，请稍后再试！");
        });
    },
    // 取消收藏
    removeCollectionHandle(id) {
      console.log(this.item)
      // this.loading = true;
      const req ={
        type:1, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 商品id
      }
      removeCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.item.isCollect = 1
            this.getcollectionList()
          }
        })
        .catch((err) => {
          this.$message.error("收藏失败，请稍后再试！");
        });
    },
     addCart(id,name,specificationlist,status,approvalStatus) {
       if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      if(status==1&&approvalStatus==1){
					addShoppingCart({
            cid: id,
            uid: this.userInfo.userId,
            number: 1,
            bxysid:0
            // bxysid:specificationlist.length>0?specificationlist[0].bXySid:0
          })
            .then((res) => {
                if (res.code == 0) {
                  this.addDialogVisible = true;          
                }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("添加购物车失败，请稍后再试！");
            });
      }else{
        this.$message.error('暂时缺货')
        return
      }
      
    },
    // 商品详情查询
    getCommoditylistDetail(id) {
      console.log("商品详情查询",this.userInfo.userId);
      this.loading = true;
      commoditylist({id: id,stype:'',userId:this.userInfo.userId})
        .then((res) => {
          if (res.code == 0) {
            console.log("res", res);
            this.loading = false;
            this.info = res.rows[0];
            this.moreImgArr = res.rows[0].more_photos.split(',');
            this.bigphotos = this.moreImgArr[0]
          }else{
             this.$message.info(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("查询失败，请稍后再试！");
        });
    },
    //   打开商品详情弹框
    openGoodsInfo(id) {
      // console.log("打开", this.openGoodsVisible);
      this.openGoodsVisible = true;
      this.getCommoditylistDetail(id)
      this.getAttributelists(id)
      this.goodsId = id

    },
    beforeClose() {
      console.log("关闭", this.openGoodsVisible);
      this.openGoodsVisible = false;
    },
    // 填写地址选择
    areaHandleChange(value) {
      this.$refs["cascaderAddr"].getCheckedNodes();
      this.ruleForm.areaid = value[value.length - 1];
      //   console.log(this.cascaderAreaValue, this.ruleForm.areaid, "填写地址选择");
    },
     // 获取商品规格
    getAttributelists(id){
        getAttributelist({productId:id})
            .then(res => {
              console.log("获取商品规格",res);
            if (res.code == 0) {
                this.attributelist = res.rows;
            } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
            }
            })
            .catch(err => {
            this.$message.error('查询商品属性失败，请稍后再试！')
            })
    },
    // // 获取地址
    // getprovinceList() {
    //   area_list()
    //     .then((res) => {
    //       if (res.code == 0) {
    //         this.getprovince = res.data;
    //       } else {
    //         this.$message({
    //           type: "info",
    //           message: res.msg,
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       //   this.editFormVisible = false;
    //       this.loading = false;
    //       this.$message.error("获取地址失败，请稍后再试！");
    //     });
    // },

      // 选规格价格发生变化
    async getgoodsSize(ids){
      this.idArr = []      
      ids.forEach((item)=>{       
         this.idArr.push(item.id)
      })
      // console.log(this.idArr,'属性数组');
      await getSpecificationDetail({productId:this.goodsId,specificationIds:this.idArr.toString()})
            .then(res => {              
            if (res.code == 0) {
                this.info.realprice = res.rows.length>0?(res.rows[0].price):(this.info.realprice||0);
                this.info.marketprice = res.rows.length>0?(res.rows[0].marketprice):(this.info.marketprice||0);
                this.selectAttrId = res.rows.length>0?(res.rows[0].id||''):'';
                this.specificationlist = res.rows.length>0?res.rows:[];
                // console.log(this.selectAttrId,res.rows[0].price,'属性')
            } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
            }
            })
            .catch(err => {
            this.$message.error('查询商品属性失败，请稍后再试！')
       })
      // this.info.realprice = value;
      // this.updateprice = updateprice;
      
    },
    // 计数量
    handleChange(value) {
      console.log(value);
      // this.info.marketprice = value*this.info.marketprice;
    },
// 获取购物车
    getshoppingCartlist() {
      shoppingCartlist({ uid: this.userInfo.userId || "" })
        .then((res) => {
          if (res.length > 0) {
            this.$store.commit("getCartList", res);
          }
        })
        .catch((err) => {
          this.$message.error("购物车查询失败，请稍后再试！");
        });
    },
     // 加入购物车
      onAddCar(id,number,bXySid,status,approvalStatus){
        if(this.userInfo.loginName==null||this.userInfo.loginName=="" ){
          this.$router.push('/login')
          return
        }
        if(status==1&&approvalStatus==1){
          if(this.attributelist.length>0){
            	if(this.selectAttrId == ''){
              this.$message({
                type: 'info',
                message: '请选择规格'
              })
              return
            }
          }else{
            this.selectAttrId = 0
          }
         addShoppingCart({
          cid: id,
          uid: this.userInfo.userId,   
          number:number,
          bxysid:this.selectAttrId
        })
          .then((res) => {
              if (res.code == 0) {            
                console.log("res", res);      
                this.openGoodsVisible = false          
                this.addDialogVisible = true;
                this.getshoppingCartlist();
              }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("添加购物车失败，请稍后再试！");
          });
	      }else{
					this.$message.error('暂时缺货')
					return
				}
        // if(this.info.specificationlist.length>0){
          
      },
    // 立即下单
      orderNow(status,approvalStatus){
        if(status==1&&approvalStatus==1){
           let selectList = [];         
            let goodList = []; 
            this.info.specificationlist = this.specificationlist
            goodList.push({
              ...this.info
            }) 
            let obj = {
              name:this.info.name,
              selectAttrId:this.selectAttrId,
              bxmId:this.info.mid,
              goods:goodList
              
            }       
            selectList.push(obj)
            sessionStorage.setItem("selectList", JSON.stringify(selectList));
            this.$router.push('/orderDetail?buyNow=true')
        }else{
          this.$message.error('暂时缺货')
					return
        }
        //  if(this.info.specificationlist.length>0){
          // if(this.selectAttrId == ''){
          //   this.$message({
          //      type: 'info',
          //      message: '请选择规格'
          //    })
          //    return
          // }
        // }       
      },

  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
    margin-bottom: 20px;
  }
  /deep/.el-tabs--border-card {
    border: 0px;
    box-shadow: unset;
    .el-tabs__header {
      border-bottom: 0px;
      background: white;
      /deep/ .el-tabs__item.is-active {
        color: #ff6700;
        background-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }
  }

 .wholeInfoBox {
    // width: 80%;
    height: auto;
    border: 1px solid #e4e4e4;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 20px;
    .addCartOpreate {
      display: none;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 60px;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      text-align: center;
      line-height: 40px;
      transition: all 0.45s ease;
    }
    .attentiontOpreate {
      display: none;
      position: absolute;
      right: 10px;
      top: 10px;
      .el-button--warning {
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        border-color: transparent;
        display: block;
        margin-left: 0 !important;
        margin-bottom: 10px;
      }
    }
    .bigImgSizeCss.el-image {
        // width: 169px;
        width: 100%;
        height: 169px;
        background: #f5f5f5;
        cursor: pointer;
        position: relative;
        /deep/.image-slot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
      }
    }
    .el-image {
        background: #f5f5f5;
        cursor: pointer;
        position: relative;
        /deep/.image-slot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
      }
    }
    .goodsText {
      text-align: center;
      margin-bottom: 4px;
    }
    .mark {
      display: none;
      font-size: 14px;
      background: rgba(255, 255, 255, 0.8);
      position: relative;
    }
  }
  .wholeInfoBox:hover {
    .addCartOpreate {
      display: block;
      cursor: pointer;
    }
    .addCartOpreate:hover {
      background: #ff6700;
    }
    .attentiontOpreate {
      display: block;
      cursor: pointer;
       button.el-button.el-button--warning.is-circle.star_on {
          background-color: rgb(255 103 0) !important;
      }
    }
    .el-button--warning:hover {
      background: #ff6700;
    }
  }

  .virtualType{
    font-size: 12px;
    font-weight: 400;
    background-color: #ff5b3d;
    color: #fff;
    padding: 4px;
    margin-right: 2px;
    border-radius: 5px;
}

  .no_goods {
    text-align: center;
    line-height: 24px;
    font-size: 14px;
  }
}
 .addCartInfoBox {
        .cascaderArea.el-cascader {
            /deep/input[disabled],
            /deep/input[disabled="disabled"],
            /deep/input[readonly],
            /deep/input[readonly="readonly"] {
            background-color: white;
            }
        }
      }
.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}
// }
</style>

 
 

 


// WEBPACK FOOTER //
// src/components/goodsCard.vue